import { useGlobal } from "reactn";
import classnames from "classnames";
import { Helmet } from "react-helmet-async";

import { MediaQuery } from "@outplayed/responsive";

import SearchBar from "components/SearchBar/SearchBar";
import LiveGameFeed from "./LiveGameFeed";
import { ReactComponent as Logo } from "svg/pbs-logo.svg";
import { RampUnit, TagBasedAdUnits } from "@outplayed/ramp";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { UGGLogoFull } from "@ugitgud/legos/ui/icon/UGGLogoFull";
import { ReactComponent as LogoFull } from "svg/logo-full.svg";

const SEOHeaders = () => {
  const title = "Probuilds Stats | The Most Up-To-Date Pro Builds, All Regions";
  const description =
    "More pros, more regions, always up-to-date. Get your League of Legend probuild needs from the newest pro player build resource. Powered by the U.GG team";
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={"https://probuildstats.com"} />
    </Helmet>
  );
};

const LandingPage = (props) => {
  const [menuOpen] = useGlobal("mobileMenuOpen");

  const landingPageClassNames = classnames("landing-page", "content-side-padding", menuOpen && "menu-open");
  return (
    <div className={landingPageClassNames}>
      <SEOHeaders />

      <div className="landing-header-wrapper">
        <div className="header-wrapper">
          <Logo className="logo" />
          <LogoFull className="logo-full" />
        </div>
        <div className="powered-by-ugg inline-flex flex-col items-start justify-start gap-y-[6px] mt-[3px]">
          <div className="text-xxs font-semibold text-[#CDDCFE]">POWERED BY</div>
          <Icon icon={<UGGLogoFull />} size="custom" className="w-[80px] h-[26px]" />
        </div>
      </div>

      <SearchBar className="landing-page_search" autoFocus />
      <MediaQuery min="TABLET" max="DESKTOP_LARGE" isClient renderNullOnFail>
        <h2 className="landing_sub-header-1">
          More pros, more regions, always up-to-date. Get your League of Legend probuild needs <br></br>
          from the newest pro player build resource. Powered by the U.GG team.
        </h2>
      </MediaQuery>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" isClient renderNullOnFail>
        <h2 className="landing_sub-header-1">
          More pros, more regions, always up-to-date. Get your League of Legend probuild needs from the newest pro player build
          resource. Powered by the U.GG team.
        </h2>
      </MediaQuery>

      <LiveGameFeed />
      <MediaQuery min="TABLET" max="DESKTOP_LARGE" isClient renderNullOnFail>
        <RampUnit className="landing-page-ads" type={TagBasedAdUnits.LeaderboardATF} id="home-leaderbaord-atf" />
      </MediaQuery>
    </div>
  );
};

export default LandingPage;
